import $ from "jquery";
import "slick-carousel";
export default class HomeSlide {
  constructor() {
    $(".home-slider").slick({
      enabled: true,
      autoplay: false,
      slickArrows: false,
      dots: true,
      rows: 0,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }
}
